import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Form, Button } from 'react-bootstrap';
import ImmutablePropTypes from 'react-immutable-proptypes';


export default class UserForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      email: props.initialEmail || '',
      role: props.initialRole,
      tableauUser: props.initialTableauUser,
    };

    this.updateEmail = this.updateEmail.bind(this);
    this.updateRole = this.updateRole.bind(this);
    this.updateTableauUser = this.updateTableauUser.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // TODO: This probably shouldn't be in here, and there should be a gate on
    // load to prevent bad data from being sent in
    if (nextProps.initialEmail !== this.props.initialEmail) {
      this.setState({ email: nextProps.initialEmail });
    }

    if (nextProps.initialRole !== this.props.initialRole) {
      this.setState({ role: nextProps.initialRole });
    }

    if (nextProps.initialTableauUser !== this.props.initialTableauUser) {
      this.setState({ tableauUser: nextProps.initialTableauUser });
    }
  }

  onSubmit() {
    this.props.onSubmit({
      email: this.state.email,
      role: this.state.role,
      tableauUser: this.state.tableauUser,
    });
  }

  updateEmail(e) {
    this.setState({ email: e.target.value });
  }

  updateRole(e) {
    this.setState({ role: e.target.value });
  }

  updateTableauUser(e) {
    this.setState({ tableauUser: e.target.value });
  }

  valid() {
    return this.state.email.length > 0 &&
      this.props.availableRoles.map((r) => r.id).indexOf(parseInt(this.state.role)) >= 0;
  }

  render() {
    return (
      <div>
        <Form onSubmit={this.onSubmit}>
          <FormGroup>
            <ControlLabel>Email Address</ControlLabel>
            <FormControl
              type='text'
              value={this.state.email}
              onChange={this.updateEmail}
              readOnly={this.props.emailReadOnly}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Role</ControlLabel>
            <FormControl
              componentClass='select'
              onChange={this.updateRole}
              value={this.state.role}
            >
              <option value={-1} key={-1}>-- Select a Role --</option>
              {
                this.props.availableRoles.map((role) =>
                  <option value={role.id} key={role.id}>{role.roleClass}</option>
                )
              }
            </FormControl>
          </FormGroup>
          <FormGroup>
            <ControlLabel>Tableau User</ControlLabel>
            <FormControl
              componentClass='select'
              value={this.state.tableauUser}
              onChange={this.updateTableauUser}
            >
              <option value={-1} key={-1}>-- Select a Tableau user --</option>
              {
                this.props.availableTableauUsers.map((t) =>
                  <option value={t.tableauUser} key={t.tableauUser}>{t.tableauUser}</option>
                )
              }
            </FormControl>
          </FormGroup>
          <Button bsStyle='primary' bsSize='large' type='submit' disabled={!this.valid()}>Submit</Button>
        </Form>
      </div>
    );
  }
}

UserForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialEmail: PropTypes.string,
  initialRole: PropTypes.number,
  initialTableauUser: PropTypes.string,
  emailReadOnly: PropTypes.bool,
  availableRoles: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      id: PropTypes.number,
      roleClass: PropTypes.string,
    }),
  ).isRequired,
  availableTableauUsers: ImmutablePropTypes.iterableOf(
    PropTypes.shape({
      tableauUser: PropTypes.string,
    }),
  ).isRequired,
};
